import Cylindre from '@amo/core/assets/images/AMO_Icons/Cylindre.svg';
import InformationsBleu from '@amo/core/assets/images/icons/informations-bleu.png';
import { Question } from '@amo/core/components/containers';
import { Radio } from '@amo/core/components/forms';
import { LargeSpinner } from '@amo/core/components/loaders';
import {getTranslation, showModal} from '@amo/core/utils/functions';
import _ from 'lodash';
import { useEffect } from 'react';
import { Field } from 'redux-form';
import carte_grise from '@amo/core/assets/images/bulle/cylindree.jpg';

const CylindreeVehicule = (props) => {
    const { nextQuestion, type, fetchCylindreeVehicule, marque_id, cylindrees, cylindree, loading, changeValue, previousQuestion } = props;

    useEffect(() => {
        marque_id && fetchCylindreeVehicule({ type, marque_id });
    }, [marque_id, fetchCylindreeVehicule, type]);

    return (
        <Question asFieldset required icon={Cylindre} title={getTranslation("vehicle.cylindreeVehicle.title")}>
            <div className={'row justify-content-center mt-2'}>
                <button
                    type="button"
                    className={'f-12 text-secondary mb-3 bg-transparent border-0 p-0'}
                    onClick={() =>
                        showModal({
                            imageUrl: carte_grise,
                            html: getTranslation("vehicle.cylindreeVehicle.registrationVehicleImg"),
                        })
                    }
                >
                    <img src={InformationsBleu} alt="" aria-hidden="true" className={'align-middle'} loading="lazy"/>{' '}
                    <span className={'pb-1 underline-link'}>{getTranslation("vehicle.cylindreeVehicle.whereFindCylindree")}</span>
                </button>

                {loading && <LargeSpinner message={getTranslation("vehicle.cylindree.Vehicle.getCylindrees")} />}

                {cylindrees &&
                    cylindrees.map((cylindree, index) => (
                        <div key={index} className={'col-lg-4 col-md-6 col-sm-6 col-6 my-2'}>
                            <Field
                                component={Radio}
                                type={'radio'}
                                name={'cylindreeVehicule'}
                                value={String(cylindree)}
                                label={cylindree}
                                className={'small'}
                            />
                        </div>
                    ))}
            </div>

            <button
                className={`btn btn-primary btn-arrow mt-4 ${!cylindree && 'disabled'}`}
                onClick={() => nextQuestion()}
            >
                {getTranslation("continue")}
            </button>
            <button
                type="button"
                className={`mt-4 d-block bg-transparent border-0 mx-auto`}
                style={{textDecoration: 'underline'}}
                onClick={() => {
                    previousQuestion();
                    changeValue('searchBy', 'immatriculation');
                }}
            >
                    Je préfère rechercher par immatriculation.
                </button>
        </Question>
    );
};

export default CylindreeVehicule;
